// Import base components
import { httpV2 } from "../http.js";

const MessagesService = {
  sendMessage: (objMessage) => httpV2.post("messaging/outbound", objMessage),
  sendInternalNote: (objMessage) => httpV2.post("messaging/internal", objMessage),
  updateInternalNote: (messageId, objMessage) =>
    httpV2.put(`messaging/internal/${messageId}`, objMessage),
  deleteInternalNote: (messageId) =>
    httpV2.delete(`messaging/internal/${messageId}`),
};

export default MessagesService;
